import { Failure } from '@mrhenry/failure';
import { UpdatePropertyData, Week } from '../api/get-calendar-data-for-house';

export type WeekData = { allowNewReservations: boolean, weeks: Week[] };

export type BookingData = {
	readonly houseId: number | null;
	readonly houseTitle: string | null;
	readonly focusDate: Date;
	readonly startOfStay: Date | null;
	readonly startOfStayAria?: string;
	readonly startOfStayFailure?: Failure;
	readonly maxPersons: number;
	readonly numberOfPersons: number;
	readonly numberOfPersonsFailure?: Failure;
	readonly numberOfNights: NumberOfNights;
	readonly numberOfNightsFailure?: Failure;
	readonly weekData: WeekData | null;
};

export type NumberOfNights = 7 | 14 | 21 | 28;

export type UpdateBookingData = UpdateHouse | UpdateFocusDate | UpdateStartOfStay | UpdateStartOfStayAndFocusDate | UpdateNumberOfPersons | UpdateNumberOfPersonsFailure | UpdateNumberOfNights | UpdateNumberOfNightsFailure | UpdatePropertyData;

type UpdateHouse = {
	readonly type: 'UPDATE_HOUSE';
	readonly houseId: number;
	readonly houseTitle: string,
	readonly maxPersons: number;
};

type UpdateFocusDate = {
	readonly type: 'UPDATE_FOCUS_DATE';
	readonly focusDate: Date;
};

type UpdateStartOfStay = {
	readonly type: 'UPDATE_START_OF_STAY';
	readonly startOfStay: Date | null;
	readonly startOfStayAria?: string;
	readonly startOfStayFailure?: Failure;
};

type UpdateStartOfStayAndFocusDate = {
	readonly type: 'UPDATE_START_OF_STAY_AND_FOCUS_DATE';
	readonly date: Date;
	readonly startOfStayAria?: string;
};

type UpdateNumberOfPersons = {
	readonly type: 'UPDATE_NUMBER_OF_PERSONS';
	readonly numberOfPersons: number;
	readonly numberOfPersonsFailure?: Failure;
};

type UpdateNumberOfPersonsFailure = {
	readonly type: 'UPDATE_NUMBER_OF_PERSONS_FAILURE';
	readonly numberOfPersonsFailure: Failure;
};

type UpdateNumberOfNights = {
	readonly type: 'UPDATE_NUMBER_OF_NIGHTS';
	readonly numberOfNights: NumberOfNights;
	readonly numberOfNightsFailure?: Failure;
};

type UpdateNumberOfNightsFailure = {
	readonly type: 'UPDATE_NUMBER_OF_NIGHTS_FAILURE';
	readonly numberOfNightsFailure: Failure;
};

export function checkIfBookingDataIsValid( weekData: WeekData | null ): boolean {
	if ( !weekData ) {
		return false;
	}

	if ( !weekData.allowNewReservations ) {
		return false;
	}

	for ( let i = 0; i < weekData.weeks.length; i++ ) {
		const week = weekData.weeks[i];

		if ( !week.priceInEuroCents ) {
			return false;
		}

		switch ( week.availability ) {
			case 'NOT_AVAILABLE':
				return false;
			case 'IS_BOOKED':
				return false;
			default:
				break;
		}
	}

	return true;
}
